import { render, staticRenderFns } from "./b-radio-select-checkbox.vue?vue&type=template&id=7126dbc5&scoped=true"
import script from "./b-radio-select-checkbox.vue?vue&type=script&lang=js"
export * from "./b-radio-select-checkbox.vue?vue&type=script&lang=js"
import style0 from "./b-radio-select-checkbox.vue?vue&type=style&index=0&id=7126dbc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126dbc5",
  null
  
)

export default component.exports